var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "flow-data", autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("b-card", { attrs: { title: "Detalle del flujo" } }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Nombre",
                    "description-text": "Nombre de la aprobación",
                    name: "nombre",
                    readonly: _vm.readOnly,
                    "data-vv-as": "nombre",
                    danger: _vm.errors.has("flow-data.nombre") && !_vm.readMode,
                    "danger-text": "El campo nombre es obligatorio",
                    "val-icon-danger": "error_outline",
                    success:
                      !_vm.errors.has("flow-data.nombre") &&
                      _vm.flow.nombre.length > 0 &&
                      !_vm.readMode,
                    "val-icon-success": "check_circle"
                  },
                  model: {
                    value: _vm.flow.nombre,
                    callback: function($$v) {
                      _vm.$set(_vm.flow, "nombre", $$v)
                    },
                    expression: "flow.nombre"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    label: "Descripción",
                    autocomplete: "off",
                    "description-text": "Descripción de la aprobación",
                    name: "descripcion",
                    readonly: _vm.readOnly,
                    "data-vv-as": "descripción",
                    danger:
                      _vm.errors.has("flow-data.descripcion") && !_vm.readMode,
                    "danger-text": "El campo descripción es obligatorio",
                    "val-icon-danger": "error_outline",
                    success:
                      !_vm.errors.has("flow-data.descripcion") &&
                      _vm.flow.descripcion.length > 0 &&
                      !_vm.readMode,
                    "val-icon-success": "check_circle"
                  },
                  model: {
                    value: _vm.flow.descripcion,
                    callback: function($$v) {
                      _vm.$set(_vm.flow, "descripcion", $$v)
                    },
                    expression: "flow.descripcion"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "vs-select",
                  {
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Doc. Referencia",
                      disabled: _vm.readOnly,
                      "description-text":
                        "Indicar si la aprobación esta referenciada por un tipo especial",
                      name: "tipoObjeto"
                    },
                    model: {
                      value: _vm.flow.tipoObjeto,
                      callback: function($$v) {
                        _vm.$set(_vm.flow, "tipoObjeto", $$v)
                      },
                      expression: "flow.tipoObjeto"
                    }
                  },
                  _vm._l(_vm.sortedReferenceApprovals, function(item) {
                    return _c("vs-select-item", {
                      key: item.opcionId,
                      attrs: { value: item.valor, text: item.descripcion }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c("OptionInputs", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.referenceOptions,
                  expression: "referenceOptions"
                }
              ],
              staticClass: "col-6",
              attrs: { reference: _vm.flow.tipoObjeto, readOnly: _vm.readOnly },
              on: {
                category: function($event) {
                  _vm.flow.tipoObjetoCategoria = $event
                },
                document: function($event) {
                  _vm.flow.tipoObjetoSubCategoria = $event
                },
                purchaseType: function($event) {
                  _vm.flow.tipoObjetoCategoria = $event
                },
                reportType: function($event) {
                  _vm.flow.tipoObjetoCategoria = $event
                }
              }
            }),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "vs-select",
                  {
                    staticClass: "w-100",
                    attrs: {
                      name: "tipoFlujo",
                      autocomplete: "",
                      label: "Tipo de flujo",
                      disabled: _vm.readOnly,
                      "description-text":
                        "Indicar si tiene un tipo especial la aprobación"
                    },
                    model: {
                      value: _vm.flow.tipoEjecucion,
                      callback: function($$v) {
                        _vm.$set(_vm.flow, "tipoEjecucion", $$v)
                      },
                      expression: "flow.tipoEjecucion"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: { value: "N", text: "Flujo normal" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: "P", text: "Flujo por rango de precios" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "vs-select",
                  {
                    staticClass: "w-100",
                    attrs: {
                      name: "unidad",
                      autocomplete: "",
                      label: "Unidad",
                      disabled: _vm.readOnly,
                      "description-text": "Indicar unidad organizacional",
                      placeholder: "Seleccione..."
                    },
                    model: {
                      value: _vm.flow.unidad,
                      callback: function($$v) {
                        _vm.$set(_vm.flow, "unidad", $$v)
                      },
                      expression: "flow.unidad"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: { value: "", text: "Seleccione..." }
                    }),
                    _vm._l(_vm.units, function(item) {
                      return _c("vs-select-item", {
                        key: item.id,
                        attrs: {
                          autocomplete: "",
                          value: item.id,
                          text: item.nombre
                        }
                      })
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _c("div", { staticClass: "col-6 mt-5" }, [
              _c(
                "div",
                [
                  _c(
                    "vs-checkbox",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            "Indicar si es posible firmar o aprobar masivamente",
                          expression:
                            "'Indicar si es posible firmar o aprobar masivamente'"
                        }
                      ],
                      staticClass: "mb-3",
                      attrs: { color: "primary", disabled: _vm.readOnly },
                      model: {
                        value: _vm.flow.masiva,
                        callback: function($$v) {
                          _vm.$set(_vm.flow, "masiva", $$v)
                        },
                        expression: "flow.masiva"
                      }
                    },
                    [_vm._v(" Procesos masivos ")]
                  ),
                  _c(
                    "vs-checkbox",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.getTooltip,
                          expression: "getTooltip"
                        }
                      ],
                      attrs: { color: "primary", disabled: _vm.readOnly },
                      model: {
                        value: _vm.flow.estampar,
                        callback: function($$v) {
                          _vm.$set(_vm.flow, "estampar", $$v)
                        },
                        expression: "flow.estampar"
                      }
                    },
                    [_vm._v(" Estampar PDF al aprobar un paso ")]
                  ),
                  _c(
                    "vs-checkbox",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            "Indicar si la aprobación se procesa automáticamente",
                          expression:
                            "'Indicar si la aprobación se procesa automáticamente'"
                        }
                      ],
                      staticClass: "mt-1",
                      attrs: { color: "primary", disabled: _vm.readOnly },
                      model: {
                        value: _vm.flow.desatendida,
                        callback: function($$v) {
                          _vm.$set(_vm.flow, "desatendida", $$v)
                        },
                        expression: "flow.desatendida"
                      }
                    },
                    [_vm._v(" Flujo desatendido ")]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }